import { InfoOutlinedIcon } from 'assets';
import { useOmniChatContext } from 'contexts';
import dayjs from 'dayjs';
import { useProfile } from 'hooks';
import { memo } from 'react';
import { twMerge } from 'tailwind-merge';
import { colorsBase } from 'themes';
import { OmniChannelMessageDto, OmniChannelSenderDto } from 'types';

type MessageAIErrorProps = {
  data: OmniChannelMessageDto;
  sender?: OmniChannelSenderDto;
};

const MessageAIError: React.FC<MessageAIErrorProps> = ({ data, sender }) => {
  const { variables } = useOmniChatContext();
  const { profile } = useProfile();
  const isMe = data.senderId === profile?.userId;

  return (
    <div
      className={twMerge(
        'relative flex min-w-[70px] max-w-[300px] items-center whitespace-pre-wrap break-words rounded-full pl-1 pr-2 text-center text-xs leading-6'
      )}
      style={{
        color: variables?.systemMessText ?? '#ffff',
        background: '#F6CFD1'
      }}
    >
      <InfoOutlinedIcon height={16} width={16} className='mr-2 text-error' color={colorsBase.error} />
      <div className='leading-6 text-error' dangerouslySetInnerHTML={{ __html: `${data.content}` }} />
      <span className='ml-2 text-xs leading-6 text-[#D1131D80]'>{dayjs(data.createdAt).format('HH:mm')}</span>
    </div>
  );
};

export default memo(MessageAIError);
